
import { LeadReport1 } from "./lead-report-1";

export const LeadReportsSection = () => {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-lg font-medium tracking-wide underline underline-offset-2">
        Lead Reports
      </h1>

      <div className="flex flex-wrap gap-6">
        <LeadReport1 />
      </div>
    </div>
  );
};
